var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main sm:container mx-auto"},[_c('transition',[_c('section',[_c('router-view',{key:_vm.$route.fullPath})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }